"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingInformationType = exports.PriceConfigurationType = exports.PaymentType = exports.ShippingRuleType = exports.ManagementFeeType = exports.ShippingMethod = void 0;
var ShippingMethod;
(function (ShippingMethod) {
    ShippingMethod["ALL"] = "ALL";
    ShippingMethod["DIGITAL"] = "DIGITAL";
    ShippingMethod["EXPRESS"] = "EXPRESS";
    ShippingMethod["PICK_UP"] = "PICK_UP";
    ShippingMethod["STANDARD"] = "STANDARD";
})(ShippingMethod = exports.ShippingMethod || (exports.ShippingMethod = {}));
var ManagementFeeType;
(function (ManagementFeeType) {
    ManagementFeeType["NONE"] = "NONE";
    ManagementFeeType["FIXED_PRICE"] = "FIXED_PRICE";
    ManagementFeeType["PERCENTAGE"] = "PERCENTAGE";
})(ManagementFeeType = exports.ManagementFeeType || (exports.ManagementFeeType = {}));
var ShippingRuleType;
(function (ShippingRuleType) {
    ShippingRuleType["FIXED_PRICE"] = "FIXED_PRICE";
    ShippingRuleType["PER_UNIT_PRICE"] = "PER_UNIT_PRICE";
    ShippingRuleType["UNIT_PRICE"] = "UNIT_PRICE";
})(ShippingRuleType = exports.ShippingRuleType || (exports.ShippingRuleType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["ALL"] = "ALL";
    PaymentType["CASH"] = "CASH";
    PaymentType["CREDIT"] = "CREDIT";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PriceConfigurationType;
(function (PriceConfigurationType) {
    PriceConfigurationType["NONE"] = "NONE";
    PriceConfigurationType["FIXED_PRICE"] = "FIXED_PRICE";
    PriceConfigurationType["PERCENTAGE"] = "PERCENTAGE";
})(PriceConfigurationType = exports.PriceConfigurationType || (exports.PriceConfigurationType = {}));
var ShippingInformationType;
(function (ShippingInformationType) {
    ShippingInformationType["DIGITAL"] = "DIGITAL";
    ShippingInformationType["FIXED_PRICE"] = "FIXED_PRICE";
    ShippingInformationType["LALAMOVE"] = "LALAMOVE";
    ShippingInformationType["MANUAL"] = "MANUAL";
    ShippingInformationType["PICKUP"] = "PICKUP";
    ShippingInformationType["POSTAL_CODE"] = "POSTAL_CODE";
    ShippingInformationType["SHIPPOP"] = "SHIPPOP";
})(ShippingInformationType = exports.ShippingInformationType || (exports.ShippingInformationType = {}));
//# sourceMappingURL=shipping.js.map